import { render, staticRenderFns } from "./portfolio.vue?vue&type=template&id=06270aa4&scoped=true&"
import script from "./portfolio.vue?vue&type=script&lang=ts&"
export * from "./portfolio.vue?vue&type=script&lang=ts&"
import style0 from "./portfolio.vue?vue&type=style&index=0&id=06270aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06270aa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VForm,VRow,VSnackbar})
